
export const icons = {
  jsonFormatter: '{ }',
  base64: '⚡',
  url: '🔗',
  hash: '#️⃣',
  uuid: '🆔',
  password: '🔐',
  jwt: '🎫',
  qrCode: '📱',
  colorPicker: '🎨',
  gradient: '🌈',
  regex: '🔍',
  htmlEntity: '🏷️',
  caseConverter: 'Aa',
  wordCounter: '📊',
  textDiff: '🔄',
  markdownPreview: '📝',
  loremIpsum: '📄',
  minifier: '🗜️',
  beautifier: '✨',
  timestampConverter: '⏰',
  unitConverter: '📏',
  csvJson: '🔄',
  xmlJson: '🔄',
  imageBase64: '🖼️',
  cssBoxShadow: '📦',
  borderRadius: '🔘',
  userAgentParser: '🌐',
  httpStatusCodes: '📡',
  mimeTypeChecker: '📁',
  stringEscape: '🔤',

  formatters: '🎨',
  encoders: '🔐',
  generators: '⚡',
  converters: '🔄',
  validators: '✅',
  text: '📝',
  color: '🌈',
  network: '🌐',

  search: '🔍',
  clear: '🗑️',
  copy: '📋',
  swap: '🔄',
  settings: '⚙️',
  close: '✕',
  menu: '☰',
  check: '✅',
  error: '❌',
  warning: '⚠️',
  info: 'ℹ️',
  success: '✅',
  
  light: '☀️',
  dark: '🌙',
  system: '💻',
  
  format: '✨',
  minify: '🗜️',
  validate: '✅',
  encode: '⚡',
  decode: '🔓',
  generate: '⚡',
  convert: '🔄',
  
  home: '🏠',
  back: '←',
  forward: '→',
  up: '↑',
  down: '↓',
  notFound: '🔍',
  serverError: '⚠️',
  
  loading: '⏳',
  done: '✅',
  failed: '❌',
  
  github: '🐱',
  twitter: '🐦',
  linkedin: '💼',
  instagram: '📷',
  email: '✉️',
  
  recent: '⚡',
  featured: '⭐',
  favorite: '❤️',
  pin: '📌',
  lock: '🔒',
  unlock: '🔓',
  download: '⬇️',
  upload: '⬆️',
  share: '🔗',
  clock: '🕐',
  
  feedback: '💬',
  bug: '🐛',
  feature: '💡',
  toolRequest: '🛠️',
  improvement: '✨',
  attachment: '📎',
  send: '📤',
  user: '👤',
  
  jsonFile: '{ }',
  xmlFile: '< >',
  csvFile: '📊',
  imageFile: '🖼️',
  textFile: '📝',
  codeFile: '💻',
  
  logo: 'dT'
};

export const getIcon = (iconName: keyof typeof icons, fallback = '�'): string => {
  return icons[iconName] || fallback;
};

export const iconCategories = {
  tools: [
    'jsonFormatter', 'base64', 'url', 'hash', 'uuid', 'password', 'jwt',
    'qrCode', 'colorPicker', 'gradient', 'regex', 'htmlEntity', 'caseConverter',
    'wordCounter', 'textDiff', 'markdownPreview', 'loremIpsum', 'minifier',
    'beautifier', 'timestampConverter', 'unitConverter', 'csvJson', 'xmlJson',
    'imageBase64', 'cssBoxShadow', 'borderRadius', 'userAgentParser',
    'httpStatusCodes', 'mimeTypeChecker', 'stringEscape'
  ],
  categories: [
    'formatters', 'encoders', 'generators', 'converters', 'validators',
    'text', 'color', 'network'
  ],
  ui: [
    'search', 'clear', 'copy', 'swap', 'settings', 'close', 'menu',
    'check', 'error', 'warning', 'info', 'success'
  ],
  theme: ['light', 'dark', 'system'],
  actions: [
    'format', 'minify', 'validate', 'encode', 'decode', 'generate', 'convert'
  ],
  navigation: ['home', 'back', 'forward', 'up', 'down', 'notFound', 'serverError'],
  status: ['loading', 'done', 'failed'],
  social: ['github', 'twitter', 'linkedin', 'instagram', 'email'],
  misc: [
    'recent', 'featured', 'favorite', 'pin', 'lock', 'unlock',
    'download', 'upload', 'share', 'feedback', 'bug', 'feature', 
    'toolRequest', 'improvement', 'attachment', 'send', 'user'
  ],
  fileTypes: ['jsonFile', 'xmlFile', 'csvFile', 'imageFile', 'textFile', 'codeFile']
};

export default icons;